import { createContext, useContext } from "react";

import type { CustomMailSettingTestMailInput } from "@/lib/gql/__generated__/graphql";

import { ProductPlanFormModelContext } from "../../_shared/context/context";

import type { ProductPlanFormModelContextType } from "../../_shared/context/context";

export type ProductNewPlanFormModelContextType = {
	onUpdate: () => Promise<void>;

	testEmailSender: {
		sendTestMailAtReservationCreate: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtReservationUpdate: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtReservationCancel: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckInBefore07Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckInBefore01Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckInBefore00Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckOutAfter01Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
	};
} & ProductPlanFormModelContextType;

export const ProductNewPlanFormModelContext = createContext<ProductNewPlanFormModelContextType | null>(null);

export const ProductNewPlanFormModelContextProvider = ({
	value,
	children,
}: {
	value: ProductNewPlanFormModelContextType;
	children: React.ReactNode;
}) => {
	return (
		<ProductNewPlanFormModelContext.Provider value={value}>
			<ProductPlanFormModelContext.Provider value={value}>{children}</ProductPlanFormModelContext.Provider>
		</ProductNewPlanFormModelContext.Provider>
	);
};

export const useProductNewPlanFormModelContext = () => {
	const context = useContext(ProductNewPlanFormModelContext);

	if (!context) {
		throw new Error(
			"useProductNewPlanFormModelContext must be used within a ProductNewPlanFormModelContextProvider",
		);
	}

	return context;
};
